import React from "react";

const PaginationPage = ({ paginationLength, totalPages, currentPage, onChangePage }) => {
    const handlePrevPage = () => {
        if (currentPage > 1) {
        onChangePage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
        onChangePage(currentPage + 1);
        }
    };

    return (
        <div className="paginationwraps">
            <button className="btn" onClick={handlePrevPage} disabled={currentPage === 1}>
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevrons-left" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M11 7l-5 5l5 5"></path>
                    <path d="M17 7l-5 5l5 5"></path>
                </svg>
            </button>
            <span> Page {currentPage} of {paginationLength?.total_records - (paginationLength?.record_limit * paginationLength?.current_page) > 0 ? paginationLength?.total_records - (paginationLength?.record_limit * paginationLength?.current_page) : 0} </span>
            <button className="btn" onClick={handleNextPage} disabled={(paginationLength?.total_records - (paginationLength?.record_limit * currentPage)  < 0 || paginationLength?.total_records - (paginationLength?.record_limit * currentPage) === 0) ? true : false}>
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevrons-right" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M7 7l5 5l-5 5"></path>
                    <path d="M13 7l5 5l-5 5"></path>
                </svg>
            </button>
        </div>
    );
};

export default PaginationPage;